export default __webpack_public_path__ + "static/media/requesticondark.1937e6e9.svg";